import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

const FilterMenu = function () {
  const { t } = useTranslation();
  const queryParams = useQueryParams();
  const current_price_filter = queryParams.get('price');

  return (
    <div className="category-menu">
      <ul>
        <li>
          <NavLink to={`?price=free`} isActive={() => current_price_filter === 'free'}>
            {t('keys.free_price')}
          </NavLink>
        </li>

        <li>
          <NavLink to={`?price=paid`} isActive={() => current_price_filter === 'paid'}>
            {t('keys.paid_price')}
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default FilterMenu;
